import { CurrencyPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { PagopaService, Pagamento } from 'app/services/pagopa.service';

@Component({
  selector: 'pagamento-pago-pa',
  template: `
<div class="flex flex-col bg-white border-2 shadow-sm rounded-xl mt-6 mb-6">
    <div class="flex flex-row justify-between bg-primary border-b rounded-t-xl py-3 px-4 md:py-4 md:px-5">

        <p class="mt-1 text-base text-white"> PAGAMENTI </p>

        <img src="assets/icons/pagopa.svg" alt="paga con pagoPA" class="h-7 mt-1 w-13 text-gray-50" *ngIf="model.stato_id !== 'pagamento'">

        <div class="mt-1 text-base text-white font-semibold" *ngIf="model.stato_id == 'pagamento'">
            <div class="flex flex-row items-center">
            <mat-icon class="icon-size-5 text-white" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
            <span class="ml-2">IN ATTESA DI PAGAMENTO</span>
            </div>
        </div>

    </div>
  <div class="p-4 md:p-5 w-full">
        <div class="mt-2">
            <ng-container *ngFor="let pagamento of pagamenti; trackBy: trackByFn">

            <div class="mx-2 px-6 py-4 border rounded border-primary mb-6">

                  <div class="flex flex-row w-full items-center justify-center gap-4 mb-4">
                      <div class="flex flex-col w-full border-b">
                        <mat-label class="font-semibold text-md">Importo totale</mat-label>
                          <div class="mt-1.5 text-secondary font-semibold uppercase">
                          <span>{{pagamento.importo | currency: 'EUR'}}</span>
                          </div>
                      </div>
                      <div class="flex flex-col w-full border-b">
                        <mat-label class="font-semibold text-md">Causale</mat-label>
                        <p class="mt-1.5 text-secondary font-semibold uppercase">presentazione istanza</p>
                      </div>
                  </div>

                <span class="mb-4 font-semibold text-secondary">Dettaglio importi:</span>

                <div>
                <ng-container *ngFor="let dettaglio of pagamento.importi; let index = index">
                    <div class="flex flex-col p-6 mt-2.5 rounded border-2 py-2.5 mb-6 bg-card">

                      <div class="grid md:grid-cols-10 sm:grid-cols-1 w-full items-center justify-center gap-4 mb-4">

                        <div class="flex flex-col w-full border-b md:col-span-2 sm:col-span-1">
                            <mat-label class="font-semibold text-md">ID</mat-label>
                            <p class="mt-1.5 text-secondary font-semibold uppercase">{{dettaglio.prog}}</p>
                          </div>

                          <div class="flex flex-col w-full border-b md:col-span-4 sm:col-span-1">
                            <mat-label class="font-semibold text-md">Importo</mat-label>
                            <div class="mt-1.5 text-secondary font-semibold uppercase">
                              <span>{{dettaglio.importo | currency: 'EUR'}}</span>
                            </div>
                          </div>

                          <div class="flex flex-col w-full border-b md:col-span-4 sm:col-span-1">
                            <mat-label class="font-semibold text-md">Causaleeeee</mat-label>
                            <p class="mt-1.5 text-secondary font-semibold uppercase">{{dettaglio?.causale ? dettaglio.causale : '-'}}</p>
                          </div>

                          <div class="flex flex-col w-full border-b">
                            <mat-label class="font-semibold text-md">Causaleeeee</mat-label>
                            <p class="mt-1.5 text-secondary font-semibold uppercase">{{dettaglio?.causale ? dettaglio.causale : '-'}}</p>
                          </div>

                          <div class="flex flex-col w-full border-b">
                            <mat-label class="font-semibold text-md">Tipo</mat-label>
                            <div class="mt-1.5 text-secondary font-semibold uppercase flex flex-row justify-between">
                              <span>{{dettaglio?.tipo_importo ? dettaglio.tipo_importo.descrizione : '-'}}</span>
                            </div>
                          </div>

                          <div class="flex flex-col w-full border-b">
                            <mat-label class="font-semibold text-md">Capitolo</mat-label>
                            <div class="mt-1.5 text-secondary font-semibold uppercase flex flex-row justify-between">
                              <span>{{dettaglio.capitolo}}</span>
                            </div>
                          </div>

                      </div>
                    </div>

                </ng-container>
                </div>
                </div>
          </ng-container>
        </div>

        <ng-container *ngIf="model.stato_id == 'pagamento'">
          <div class="flex flex-row items-end justify-end gap-4">

            <button aria-expanded="false"
              class="italia-it-button sm:w-[150px] sm:h-[30.688px] md:w-[220px] md:h-[46.031px] lg:w-[280px] lg:h-[61.391px] button-spid "
              aria-haspopup="true" aria-expanded="false">
              <span class="italia-it-button-icon"><img
                      class="md:ml-1.5 lg:ml-3 xl:ml-4 sm:w-[19px] sm:h-[19px] md:w-[29px] md:h-[29px] lg:w-[38px] lg:h-[38px]"
                      src="assets/icons/pagopa.svg"
                      onerror="this.src='assets/icons/pagopa.svg'; this.onerror=null;"
                      alt="logo cns" /></span>
                <div class="inline-block gap-2 md:mt-3">
                <a class="md:w-50 md:pt-5 sm:text-sm md:text-2xl">Scarica avviso</a>
                <mat-icon class="ml-2 text-white icon-size-5" [svgIcon]="'heroicons_solid:arrow-down-tray'"></mat-icon></div>
          </button>

              <button aria-expanded="false"
              class="italia-it-button sm:w-[150px] sm:h-[30.688px] md:w-[220px] md:h-[46.031px] lg:w-[280px] lg:h-[61.391px] button-spid "
              aria-haspopup="true" aria-expanded="false">
              <span class="italia-it-button-icon"><img
                      class="md:ml-1.5 lg:ml-3 xl:ml-4 sm:w-[19px] sm:h-[19px] md:w-[29px] md:h-[29px] lg:w-[38px] lg:h-[38px]"
                      src="assets/icons/pagopa.svg"
                      onerror="this.src='assets/icons/pagopa.svg'; this.onerror=null;"
                      alt="logo pagopa" /></span>
              <a class="flex flex-col md:w-50 md:pt-5 sm:text-sm md:text-2xl">paga con pagoPa</a>
          </button>

          </div>
      </ng-container>

      </div>


</div>
  `,
  styles:[
    `.italia-it-button {
      display: inline-block;
      position: relative;
      padding: 0;
      color: #fff;
      font-family: "Titillium Web", HelveticaNeue, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
      font-weight: 600;
      line-height: 1em;
      text-decoration: none;
      border: 0;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
  }
  .italia-it-button-icon,
  .italia-it-button-text {
      display: block;
      float: left;
  }
  .italia-it-button-icon {
      margin: 0 -0.4em 0 0;
      padding: 0.6em 0.8em 0.5em;
      border-right: rgba(255, 255, 255, 0.1) 0.1em solid;
  }
  .italia-it-button-text {
      padding: 0.95em 1em 0.85em 1em;
      text-align: center;
  }
  svg {
      width: 1.8em;
      height: 1.8em;
      fill: #fff;
  }
  .italia-it-block {
      display: block;
  }
  .italia-it-button-size-s {
      font-size: 10px;
      width: 150px;
  }
  .italia-it-button-size-s > span img {
      width: 19px;
      height: 19px;
      border: 0;
  }
  .italia-it-button-size-m {
      font-size: 15px;
      width: 220px;
  }
  .italia-it-button-size-m > span img {
      width: 29px;
      height: 29px;
      border: 0;
  }
  .italia-it-button-size-l {
      font-size: 20px;
      width: 280px;
  }
  .italia-it-button-size-l > span img {
      width: 38px;
      height: 38px;
      border: 0;
  }
  .italia-it-button-size-xl {
      font-size: 25px;
      width: 340px;
  }
  .italia-it-button-size-xl > span img {
      width: 47px;
      height: 47px;
      border: 0;
  }
  .button-spid {
      background-color: #2f467c;
      color: #fff;
  }
  .button-spid svg {
      fill: #fff;
  }
  .button-spid:hover {
      background-color: #036;
      color: #fff;
  }
  .button-spid:active {
      background-color: #83beed;
      color: #036;
  }
  .spid-idp-button {
      position: absolute;
      z-index: 1039;
      display: none;
  }
  .spid-idp-button .spid-idp-button-menu,
  .spid-idp-button .spid-idp-button-panel {
      list-style: none;
      background: white;
      border: solid 1px #ddd;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      overflow: visible;
      padding: 0;
      margin: 0;
  }



  #spid-idp-button-small-get,
  #spid-idp-button-medium-get,
  #spid-idp-button-small-post,
  #spid-idp-button-medium-post {
      width: 230px;
  }
  #spid-idp-button-large-get,
  #spid-idp-button-large-post {
      width: 270px;
  }
  #spid-idp-button-xlarge-get,
  #spid-idp-button-xlarge-post {
      width: 330px;
  }
  .spid-idp-button .spid-idp-button-panel {
      padding: 10px;
  }
  .spid-idp-button.spid-idp-button-tip {
      margin-top: 8px;
  }
  .spid-idp-button.spid-idp-button-tip:before {
      position: absolute;
      top: -6px;
      left: 9px;
      content: "";
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #ddd;
      display: inline-block;
  }
  .spid-idp-button.spid-idp-button-tip:after {
      position: absolute;
      top: -5px;
      left: 10px;
      content: "";
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid white;
      display: inline-block;
  }
  .spid-idp-button.spid-idp-button-tip.spid-idp-button-anchor-right:before {
      left: auto;
      right: 9px;
  }
  .spid-idp-button.spid-idp-button-tip.spid-idp-button-anchor-right:after {
      left: auto;
      right: 10px;
  }
  .spid-idp-button.spid-idp-button-scroll .spid-idp-button-menu,
  .spid-idp-button.spid-idp-button-scroll .spid-idp-button-panel {
      max-height: 180px;
      overflow: auto;
  }
  .spid-idp-button .spid-idp-button-menu li {
      list-style: none;
      padding: 0 0;
      margin: 0;
      line-height: 18px;
  }
  .spid-idp-button .spid-idp-button-menu li > a,
  .spid-idp-button .spid-idp-button-menu label {
      display: block;
      font-family: "Titillium Web", HelveticaNeue, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
      font-weight: 600;
      font-size: 0.9em;
      color: #06c;
      text-decoration: underline;
      line-height: 18px;
      padding-top: 5px;
      white-space: nowrap;
      border-bottom: 1px solid #ddd;
  }
  .spid-idp-button .spid-idp-button-menu li > a:hover,
  .spid-idp-button .spid-idp-button-menu label:hover {
      color: #036;
      cursor: pointer;
      background-color: #f0f0f0;
  }
  .spid-idp-button .spid-idp-button-menu li > a img {
      height: 25px;
      padding: 10px 0 10px 10px;
      border: 0;
  }
  .idp-button-idp-logo {
      font-size: 100%;
      height: 10%;
      width: 100%;
      border: 0;
      border-bottom: 1px solid #ccc;
      background-color: #fff;
      padding: 15px;
      text-align: left;
      cursor: pointer;
  }
  .idp-button-idp-logo:hover {
      background-color: #f0f0f0;
  }
  .idp-button-idp-logo img {
      height: 25px;
      vertical-align: middle;
      cursor: pointer;
  }
  .spid-top-menu-space-10 > a img {
      margin-top: 10px;
  }
  .spid-top-menu-space-20 > a img {
      margin-top: 20px;
  }
  .spid-top-menu-line {
      border-top: 5px solid #000;
  }
  .spid-idp-support-link > a {
      padding: 5px 0 10px 10px;
  }
  .spid-sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
  }
  `
  ],
  standalone: true,
  imports: [FormlyModule, MatIconModule, MatButtonModule, NgIf, NgFor, MatFormFieldModule, MatBadgeModule, CurrencyPipe]
})
export class PagamentoComponent extends FieldWrapper implements OnInit {

  pagamenti: Pagamento[];
  numeroPagamenti:number=0;

  ngOnInit(): void {
    this.pagamenti = this.model.pagamenti
    this.numeroPagamenti = this.pagamenti.length
  }


  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

}



